import { cart, pubsub } from '@services';

class CartItemCount extends HTMLElement {
  unsubscribers = [];

  static {
    cart.sections.push('fetch-cart-item-count');
  }

  connectedCallback() {
    ['cart:add', 'cart:update', 'cart:change'].forEach(event =>
      this.unsubscribers.push(
        pubsub.subscribe(event, ({ sections }) => this.renderSection(sections)),
      ),
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach(unsubscribe => unsubscribe());
  }

  /**
   * Add cart count
   */
  renderSection(sections) {
    const html = new DOMParser().parseFromString(sections['fetch-cart-item-count'], 'text/html');
    const target = html.querySelector('cart-item-count');
    this.replaceWith(target);
  }
}

customElements.define('cart-item-count', CartItemCount);
